import { HIDE_DUPLICATES, SHOW_DUPLICATES } from '../actions/duplicates';
import { CHANGE_SELECTED_COMPANIES, CHANGE_SELECTED_PEOPLE } from '../actions/select_list';

export default function (state = {}, action) {
  switch (action.type) {
  case CHANGE_SELECTED_COMPANIES:
    return { ...state, selectedCompanyIds: action.companies };
  case CHANGE_SELECTED_PEOPLE:
    return { ...state, selectedPersonIds: action.people };
  case HIDE_DUPLICATES:
  case SHOW_DUPLICATES:
    return { ...state, selectedCompanyIds: [], selectedPersonIds: [] };
  default:
    return state;
  }
}
